import { render, staticRenderFns } from "./addapp.vue?vue&type=template&id=0cca6c3b&scoped=true"
import script from "./addapp.vue?vue&type=script&lang=js"
export * from "./addapp.vue?vue&type=script&lang=js"
import style0 from "./addapp.vue?vue&type=style&index=0&id=0cca6c3b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cca6c3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-manage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cca6c3b')) {
      api.createRecord('0cca6c3b', component.options)
    } else {
      api.reload('0cca6c3b', component.options)
    }
    module.hot.accept("./addapp.vue?vue&type=template&id=0cca6c3b&scoped=true", function () {
      api.rerender('0cca6c3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apply/addapp.vue"
export default component.exports